export default "__VITE_ASSET__CfRgJGkD__"